import {
    RenderActDocumentCell,
    RenderActScanCell,
    RenderStatusCell,
    RenderViolationsCell
} from "../components/ActTable/ActTable";
import {Statuses, STATUSES_RU, STATUSES_RU_ABBREVIATED} from "./actStatuses";

const createValueOptions = (values, labels) => {
    return Object.entries(values).map(el => ({
        value: el[1],
        label: labels[el[0]]
    }))
}

const createColumn = (columnConfig) => {
    switch (columnConfig.type) {
        case 'skan':
            return {
                field: 'files',
                headerName: 'Сканы',
                width: 80,
                filterable: false,
                sortable: false,
                renderCell: RenderActScanCell
            }
        case 'date-time':
            return {...columnConfig, ...{renderCell: RenderViolationsCell}}
        case 'text-field':
            return {...columnConfig, ...{renderCell: RenderViolationsCell}}
        default:
            return {...columnConfig, ...{renderCell: RenderViolationsCell}}
    }
}

export const createColumns = (tableTemplateContentColumns, enableSequenceNumber) => {
    const rightSideColumns = [
        // {
        //     field: 'violations',
        //     headerName: 'Нарушения',
        //     flex: 2,
        //     renderCell: RenderViolationsCell
        // },
        {
            field: 'status',
            headerName: 'Ст',
            type: 'singleSelect',
            valueOptions: createValueOptions(Statuses, STATUSES_RU_ABBREVIATED),
            width: 80,
            renderCell: RenderStatusCell
        },
        {
            field: 'actFile',
            headerName: `docx xlsx`,
            width: 115,
            filterable: false,
            sortable: false,
            renderCell: RenderActDocumentCell
        },
        // {
        //     field: 'files',
        //     headerName: 'Сканы',
        //     width: 80,
        //     filterable: false,
        //     sortable: false,
        //     renderCell: RenderActScanCell
        // },

    ]
    if (tableTemplateContentColumns) {
        if (enableSequenceNumber) {
            return [
                {field: 'sequenceNumber', headerName: ' ', width: 50},
                {field: 'id', headerName: 'ID', width: 80},
                ...tableTemplateContentColumns?.map(column => createColumn(column, enableSequenceNumber)),
                ...rightSideColumns,
            ]
        }
        return [{field: 'id', headerName: 'ID', width: 80},
            ...tableTemplateContentColumns?.map(column => createColumn(column, enableSequenceNumber)),
            ...rightSideColumns
        ]
    }
}

const createRow = (act, index, enableSequenceNumber) => {
    const row = {}
    for (const [key, value] of Object.entries(act.content)) {
        if (!Array.isArray(value)) {
            if (value?.data !== undefined) {
                for(let dataObj of value.data) {
                    for(let [key3, value3] of Object.entries(dataObj)) {
                        row[key3] = row[key3] !== undefined ? row[key3] + '\n' + value3 : value3
                    }
                }
            } else {
                row[key] = value
            }
        } else {
            for(let elOffenseList of value) {
                for (const [key2, value2] of Object.entries(elOffenseList)) {
                    row[key2] = row[key2] !== undefined ? row[key2] + '\n' + value2 : value2
                }
            }
        }
    }
    for (const [key, value] of Object.entries(act.raw_content)) {
            if ((!Array.isArray(value)) && (row[key] === undefined))  {
              //  row[key] = value
            
              let fvalue = (value != null)  ? String(value).replace('-','').replace('-','') : '';

              let tempDate = new Date(Date.parse(fvalue.substring(0,4)+'-'+fvalue.substring(4,6)+'-'+fvalue.substring(6,fvalue.length)));
              
              if (tempDate.getMonth)
                row[key] = fvalue.substring(0,4)+'-'+fvalue.substring(4,6)+'-'+fvalue.substring(6,8)+' '+fvalue.substring(9,11)+':'+fvalue.substring(12,14);
            }
    }
    if (enableSequenceNumber) {
        row.sequenceNumber = index + 1
    }
    row.id = act.id
    // row.violations = act.violations
    row.status = act.status
    row.actFile = {actId: act.id, environmentStateId: act.environment_state}
    row.files = act.files
    return row
}

export const createRows = (acts, enableSequenceNumber) => {
    if (acts && acts.length !== 0 && !(typeof enableSequenceNumber === 'undefined' || enableSequenceNumber === null)) {
        return acts.map((act, index) => createRow(act, index, enableSequenceNumber))
    }
    return []
}